import { IFleetKarhoo, ITripSelectedDetails } from "models/TripInterface";
import { createContext, useState } from "react";
import { initLogged, initSession, initReturnTripSummaryDetail, initTripSummaryDetail, initUserDetail, IUserData, RaaSSession, initFleetKarhooName, initstepOnBoarding, checkLoggedSocialStorage, isRedirectionByAmplifyLogin, initTMBSummaryDetail, initActivityGlobick, initBookingGlobick, initTokenGlobick, initPostTokenGlobick, initTypeTrip, initbodyLongMover, initConfimedTarifs, initTokenVeridas, initNextToMeData } from "../services/user/user.session.service";
import { UtilProvider } from "./util.context"
import { ActivityCard, BookingGlobick } from "models/globick";

const RaaSContext = createContext({
    logged: initLogged() as boolean,
    loggedSocial: checkLoggedSocialStorage() as boolean,
    loadingRedirectBySocial: false as boolean,
    session: initSession() as RaaSSession,
    userConnected: {} as IUserData,
    tripSelectedDetails: {} as ITripSelectedDetails,
    tripReturnSelectedDetails: {} as ITripSelectedDetails,
    fleetKarhooName: {} as IFleetKarhoo,
    stepOnBoarding:initstepOnBoarding() as boolean,
    cardTMB: {} as any,
    productTMBDetails: {} as any,
    typeTrip:initTypeTrip() as any,
    activityGlobick:initActivityGlobick() as ActivityCard,
    bookingGlobick:initBookingGlobick() as BookingGlobick,
    tokenGlobick: initTokenGlobick() as any,
    postBookingGlobick:initPostTokenGlobick() as any,
    bodyLongMover:initbodyLongMover() as any,
    confirmedTarifs:initConfimedTarifs() as any,
    tokenVeridas:initTokenVeridas() as any,
    nextToMeData:initNextToMeData() as any,
    setLogged: ((log: boolean) => { }),
    setLoggedSocial: ((log: boolean) => { }),
    setLoadingRedirectBySocial: ((log: boolean) => { }),
    setSession: ((session: RaaSSession) => { }),
    setUserConnected: ((userData: IUserData) => { }),
    setTripSelectedDetails: ((tripSelected: ITripSelectedDetails) => { }),
    setReturnTripSelectedDetails: ((tripSelected: ITripSelectedDetails) => { }),
    setFleetKarhooName: ((fleetName: IFleetKarhoo) => { }),
    setStepOnBoarding: ((step: boolean) => { }),
    setCardTMB: ((cardTMB: any) => { }),
    setProductTMBDetails: ((productSelected: any) => { }),
    setTypeTrip:((typeTrip:any)=>{}),
    setActivityGlobick: ((activityGlobick: any) => { }),
    setBookingGlobick: ((bookingGlobick: any) => { }),
    setTokenGlobick: ((tokenGlobick: any) => { }),
    setPostBookingGlobick: ((tokenGlobick: any) => { }),
    setBodyLongMover: ((bodyLongMover: any) => { }),  
    setConfirmedTarifs: ((confirmedTarifs: any) => { }), 
    setTokenVeridas: ((confirmedTarifs: any) => { }), 
    setNextToMeData: ((nextToMeData: any) => { }), 
    
    
    
    
})

/**: 
 * @description global aplication context
 */
export function RaaSContextProvider({ children }: any) {

    const [logged, setLogged] = useState<boolean>(initLogged());
    const [loggedSocial, setLoggedSocial] = useState<boolean>(checkLoggedSocialStorage());
    const [loadingRedirectBySocial, setLoadingRedirectBySocial] = useState<boolean>(isRedirectionByAmplifyLogin());
    const [session, setSession] = useState<any>(initSession());
    const [userConnected, setUserConnected] = useState<any>(initUserDetail());
    const [tripSelectedDetails, setTripSelectedDetails] = useState<any>(initTripSummaryDetail());
    const [tripReturnSelectedDetails, setReturnTripSelectedDetails] = useState<any>(initReturnTripSummaryDetail());
    const [fleetKarhooName, setFleetKarhooName] = useState<any>(initFleetKarhooName());
    const [stepOnBoarding, setStepOnBoarding] = useState<boolean>(initstepOnBoarding());
    const [cardTMB, setCardTMB] = useState<any>();
    const [productTMBDetails, setProductTMBDetails] = useState<any>(initTMBSummaryDetail());
    const [activityGlobick, setActivityGlobick] = useState<any>(initActivityGlobick());
    const [bookingGlobick, setBookingGlobick] = useState<any>(initBookingGlobick());
    const [tokenGlobick, setTokenGlobick] = useState<any>(initTokenGlobick());
    const [postBookingGlobick, setPostBookingGlobick] = useState<any>(initPostTokenGlobick());
    const [typeTrip, setTypeTrip] = useState<any>(initTypeTrip());
    const [bodyLongMover, setBodyLongMover] = useState<any>(initbodyLongMover());
    const [confirmedTarifs, setConfirmedTarifs] = useState<any>(initConfimedTarifs());
    const [tokenVeridas, setTokenVeridas] = useState<any>(initTokenVeridas());
    const [nextToMeData, setNextToMeData] = useState<any>(initNextToMeData());
    
    
    return (
        <RaaSContext.Provider value={{ logged, loggedSocial, loadingRedirectBySocial, session, userConnected, tripSelectedDetails, tripReturnSelectedDetails, fleetKarhooName,stepOnBoarding,cardTMB,productTMBDetails,activityGlobick, bookingGlobick,tokenGlobick,postBookingGlobick,typeTrip,bodyLongMover,confirmedTarifs,tokenVeridas,nextToMeData,setLogged, setLoggedSocial, setLoadingRedirectBySocial, setSession, setUserConnected, setTripSelectedDetails, setReturnTripSelectedDetails, setFleetKarhooName,setStepOnBoarding,setCardTMB,setProductTMBDetails,setActivityGlobick,setBookingGlobick,setTokenGlobick,setPostBookingGlobick,setTypeTrip,setBodyLongMover ,setConfirmedTarifs,setTokenVeridas,setNextToMeData}}>
            <UtilProvider>
                {children}
            </UtilProvider>
        </RaaSContext.Provider>
    )

}

export default RaaSContext;